import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../../Layout/MainLayout';
import { useEffect } from 'react';
import { useCreateWebhookMutation } from '../../../../api/webhooks';
import { useIdempotencyKey } from '../../../../hooks/useIdempotencyKey';
import { MainBreadcrumbs } from '../../../Layout/MainBreadcrumbs';
import { Route } from '../../../../routes/account.business_.webhooks_.add';
import { WebhookForm } from './WebhookForm';

export function AddWebhookPage() {
  const { t } = useTranslation();
  const navigate = Route.useNavigate();
  const idempotencyKey = useIdempotencyKey();
  const createWebhookMutation = useCreateWebhookMutation({ idempotencyKey });

  useEffect(() => {
    if (createWebhookMutation.data) {
      navigate({
        to: '/account/business/webhooks/$webhookId',
        params: { webhookId: createWebhookMutation.data.id },
        replace: true,
      });
    }
  }, [navigate, createWebhookMutation.data]);

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Create Webhook')}
          parent={{
            to: '/account/business',
            title: t('Your business'),
          }}
        />
      }
      compact
    >
      <WebhookForm mutation={createWebhookMutation} />
    </MainLayout>
  );
}
